import { ReactNode } from 'react';

/* eslint-disable no-restricted-imports */
import {
  Table as TableMUI,
  TableBody,
  TableHead,
  TableRow,
  TableContainer,
  TableCell,
  styled,
} from '@mui/material';

import { Row } from './components/Row';
import { Cell } from './components/Cell';

export type TableProps = {
  children: ReactNode;
  headers: string[];
};

const StyledHead = styled(TableHead)({
  backgroundColor: 'transparent',
  borderBottom: '1px solid var(--stroke-stroke-primary-color)',
});

const StyledTh = styled(TableCell)(({ theme }) => ({
  textAlign: 'left',
  padding: theme.spacing(4),
  whiteSpace: 'nowrap',
  fontWeight: 400,
  fontSize: '12px',
  borderBottom: 'none',
  lineHeight: '16px',
  color: 'var(--text-text-secondary-color)',
  '&:first-child': {
    paddingLeft: 0,
  },
  '&:last-child': {
    paddingRight: 0,
  },
}));

export const Table = ({ headers, children }: TableProps) => {
  return (
    <TableContainer sx={{ overflowX: 'auto' }}>
      <TableMUI>
        <StyledHead>
          <TableRow>
            {headers.map((header, index) => (
              <StyledTh key={index}>{header}</StyledTh>
            ))}
          </TableRow>
        </StyledHead>
        <TableBody>{children}</TableBody>
      </TableMUI>
    </TableContainer>
  );
};

Table.Row = Row;
Table.Cell = Cell;
